import { required, requiredIf } from 'vuelidate/lib/validators';

const leadQualityScoreInRange = (value, parent) => {
  if (!parent || parent.attribute_key !== 'lead_quality_score') return true;
  const single = Array.isArray(value) ? value[0] : value;
  if (single === '' || single === null || single === undefined) return true;
  const n = Number(single);
  return Number.isFinite(n) && Number.isInteger(n) && n >= 1 && n <= 100;
};

const reengagementCountValid = (value, parent) => {
  if (!parent || parent.attribute_key !== 'reengagement_count') return true;
  const single = Array.isArray(value) ? value[0] : value;
  if (single === '' || single === null || single === undefined) return true;
  const n = Number(single);
  return Number.isFinite(n) && Number.isInteger(n) && n >= 0;
};

const kivoWebhookParamsValid = (value, action) => {
  if (!action || action.action_name !== 'send_kivo_notification') return true;

  const params = value || {};
  const url = typeof params.url === 'string' ? params.url.trim() : '';
  const text = typeof params.text === 'string' ? params.text.trim() : '';

  return url.length > 0 && text.length > 0;
};

export default {
  validations: {
    automation: {
      name: {
        required,
      },
      description: {
        required,
      },
      event_name: {
        required,
      },
      conditions: {
        required,
        $each: {
          values: {
            required: requiredIf(prop => {
              return !(
                prop.attribute_key === 'meeting_present' ||
                prop.filter_operator === 'is_present' ||
                prop.filter_operator === 'is_not_present'
              );
            }),
            leadQualityScoreInRange,
            reengagementCountValid,
          },
        },
      },
      actions: {
        required,
        $each: {
          action_params: {
            required: requiredIf(prop => {
              return !(
                prop.action_name === 'mute_conversation' ||
                prop.action_name === 'snooze_conversation' ||
                prop.action_name === 'resolve_conversation' ||
                prop.action_name === 'gather_lead_quality_score' ||
                prop.action_name === 'send_kivo_notification'
              );
            }),
            kivoWebhookParamsValid,
          },
        },
      },
    },
  },
};
